import { IRequestListEmployees, IResponseListEmployees } from './user';
import { getAxios } from 'hooks/useAxios';
import { ENDPOINTS } from 'services/endpoints';

const api = getAxios();
export interface IRequestAllIndicatorsEmployees {
	companies_id?: string[];
	sellers_id?: string[];
	year?: string;
	month?: string;
}

interface Indicator {
	indicator: string;
	average: number;
}

interface EmployeeCompanyIndicator {
	[nome: string]: Indicator[];
}

export interface ICompaniesAllEmployees {
	company: string;
	id?: string;
	employees: EmployeeCompanyIndicator[];
}

export const getAllEmployeesIndicators = async ({
	companies_id,
	sellers_id,
	year,
	month,
}: IRequestAllIndicatorsEmployees): Promise<ICompaniesAllEmployees[]> => {
	const response = await api.post(ENDPOINTS.getAllEmployessIndicators, { companies_id, sellers_id, year, month });
	return response.data;
};

export const getListEmployeesNoPaginate = async (params?: IRequestListEmployees): Promise<IResponseListEmployees> => {
	const requestParams = { ...params };

	if (requestParams?.companies && Array.isArray(requestParams.companies)) {
		requestParams.companies = requestParams.companies.join(',');
	}

	const response = await api.get<IResponseListEmployees>(
		`${ENDPOINTS.listEmployees}?paginate=false&only_sellers=true`,
		{
			params: requestParams,
		},
	);
	return response.data;
};
